<template>
  <div>
    <div class="row">
      <div class="col-md-6 col-sm-12 col-12 q-pa-xs">
        <q-toggle
          dense
          style="margin-top: "
          v-model="toggles"
          checked-icon="toggle_on"
          unchecked-icon="toggle_off"
          label=" Indicator Filter (as of Latest Date)"
          class="text-primary text-bold gt-sm"
        >
          <q-tooltip content="Uesr-Profile" class="bg-primary">
            Indicator Filter
          </q-tooltip>
        </q-toggle>
        <ListCardTableView
          :isStatusValid="isStatusValid"
          :tableTitle="tableTitle"
          :timePeriod="timePeriod"
          :buttonBuyOrSell="buttonBuyOrSell"
          v-if="buyData || sellData"
          :buyData="buyData"
          :sellData="sellData"
          :alertOrSignal="alertOrSignal"
          :indicatorsSymbols="indicatorsSymbols"
          :indicatorsDate="indicatorsDate"
          :indicatorsValue="indicatorsValue"
          @selectedSymbol="(eventSymbol) => (symbol = eventSymbol)"
          @EmitActiveInstance="
            (eventData) => {
              activeInstance = eventData;
            }
          "
        />
      </div>

      <div class="col-md-6 q-pl-md-md col-sm-12 col-12">
        <AllIndicatorsFilter
          :isToggle="toggles"
          @selectedIndIcatorSymbol="
            (eventSymbol) => {
              indicatorsSymbols = eventSymbol;
            }
          "
          @selectedIndIcatorDate="
            (eventDate) => {
              indicatorsDate = eventDate;
            }
          "
          @selectedIndIcatorValue="
            (eventValue) => {
              indicatorsValue = eventValue;
            }
          "
        />

        <TableView
          class="q-mb-md"
          :title="tableTitle"
          :timePeriod="timePeriod"
          :symbol="activeInstance?.symbol"
          :volume="activeInstance?.volume"
          :avg_vol="activeInstance?.avg_vol"
          :date="activeInstance?.date"
          :alert_date="activeInstance?.alert_date"
          :deviation="activeInstance?.deviation?.toFixed(2)"
          :single_body_candle="activeInstance?.single_body_candle"
          :double_body_candle="activeInstance?.double_body_candle"
          :triple_body_candle="activeInstance?.triple_body_candle"
          :four_body_candle="activeInstance?.four_body_candle"
          :star_pattern="activeInstance?.star_pattern"
          :entry_point="activeInstance?.entry_point"
          :stop_loss="activeInstance?.stop_loss?.toFixed(2)"
          :profit_target="activeInstance?.profit_target?.toFixed(2)"
          :risk_reward="activeInstance?.risk_reward?.toFixed(2)"
          :buttonBuyOrSell="buttonBuyOrSell"
          :tableType="alertOrSignal"
        ></TableView>
        <StockwiseKeyValueComponents
          v-if="activeInstance?.symbol"
          :symbol="activeInstance?.symbol"
          class="q-mt-m"
        />
      </div>
    </div>
    <div>
      <StockWiseTabbedStatistics
        v-if="symbol"
        class="q-mt-sm"
        :symbol="symbol"
        :isSignalType="true"
        :signalTypeData="activeInstance"
        :indicators="indicators"
        :enableDailyWeeklyIntraday="true"
        :buttonBuyOrSell="buttonBuyOrSell"
        :alertOrSignal="alertOrSignal"
        :timePeriod="timePeriod"
      />
    </div>
  </div>
</template>

<script>
import { ref, watch, computed, nextTick } from "vue";
import ListCardTableView from "src/components/TradingSignalsAndType/ListCardTableView.vue";
import TableView from "src/components/TableView.vue";
import StockwiseKeyValueComponents from "src/components/PriceActionSignals/StockwiseKeyValueComponents.vue";

import AllIndicatorsFilter from "src/components/Indicators/AllIndicatorsFilter.vue";
import StockWiseTabbedStatistics from "src/components/StockWiseTabbedStatistics.vue";

export default {
  name: "ListCardTableViewTradingView",
  emits: ["selectedSymbol", "selectedSymbolDate", "activeInstance"],
  props: {
    indicators: {
      type: Array,
      default: () => [],
    },
    buyData: { type: Array },
    sellData: { type: Array },
    buttonBuyOrSell: { type: String },
    alertOrSignal: {
      type: String,
    },
    timePeriod: {
      type: String,
    },
    tableTitle: {
      type: String,
    },
    isStatusValid: { type: Boolean, default: true },
    signalTypeData: { type: Array },
  },
  components: {
    StockwiseKeyValueComponents,
    ListCardTableView,
    AllIndicatorsFilter,
    StockWiseTabbedStatistics,
    TableView,
  },

  setup(props, context) {
    let symbol = ref("");
    let selectedSymbol = ref("");
    let selectedDate = ref(null);
    const activeInstance = ref([]);
    const indicatorsSymbols = ref([]);
    const indicatorsDate = ref([]);
    const indicatorsValue = ref([]);
    const toggles = ref(false);

    watch(selectedSymbol, (newVal, oldVal) => {
      context.emit("selectedSymbol", selectedSymbol.value);
      context.emit(
        "selectedSymbolDate",
        selectedSymbol.value,
        selectedDate.value
      );
    });

    return {
      selectedSymbol,
      selectedDate,
      activeInstance,
      symbol,

      indicatorsSymbols,
      indicatorsDate,
      indicatorsValue,
      toggles,
    };
  },
};
</script>
